import { trpc } from '@web-app/utils/trpc';

const STALE_TIME = 5 * 60 * 1000;

/**
 * Fetches the patient's Factor meal-delivery summary.
 *
 * Standalone hook — works in any context. Gated on an explicit `enabled`
 * param so callers can tie it to a feature flag without the hook needing
 * to know about GrowthBook.
 *
 * The server calls the Platform AI `POST /v1/factor-meal-summary` endpoint.
 * When `isFactorPatient` is false in the response, the card is hidden.
 */
export function useFactorMealSummary(
  patientId: string | null | undefined,
  enabled: boolean,
) {
  const { data, isPending, error } =
    trpc.sessionPrep.getFactorMealSummary.useQuery(
      { patientId: patientId ?? '' },
      {
        enabled: enabled && !!patientId,
        staleTime: STALE_TIME,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    );

  return {
    mealSummary: data ?? null,
    isLoading: enabled && !!patientId && isPending,
    error: (error as Error | null) ?? null,
  };
}
